import { booleanAttribute, ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  DsAutosuggestModule,
  DsFormFieldModule,
  DsIconModule,
  SuggestionItem,
  SuggestionItemsFilter,
} from '@bmw-ds/components';
import { of } from 'rxjs';

@Component({
  selector: 'cdf-input-field',
  host: { class: 'col' },
  imports: [DsFormFieldModule, FormsModule, DsAutosuggestModule, DsIconModule],
  template: `
    <input
      ds-input
      ds-autosuggest
      [(ngModel)]="model"
      [attr.aria-invalid]="displayError()"
      [attr.maxlength]="maxLength()"
      [class.validate-when-untouched]="!validateWhenTouchedOnly()"
      [id]="id()"
      [placeholder]="placeholder() ?? ''"
      [attr.title]="title() ?? placeholder()"
      [customFilter]="filterItems"
      [minCharsToFilter]="0"
      [disabled]="disabled()"
      [items]="suggestions() ?? []"
      [overlayConfig]="{ minWidth: '80px' }"
      (suggestionSelected)="suggestionSelected.emit($event)"
      data-1p-ignore
    />

    @if (displayError() && errorMessage()) {
      <div class="error-message">
        <ds-icon icon="information" size="sm" />
        <span class="text-label">{{ errorMessage() }}</span>
      </div>
    }
  `,
  styleUrl: './input-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputFieldComponent {
  readonly model = model<string>();
  readonly id = input.required<string>();
  readonly placeholder = input<string>();

  readonly suggestions = input<SuggestionItem[]>();
  readonly suggestionSelected = output<SuggestionItem>();

  readonly displayError = input(false);
  readonly errorMessage = input<string>();
  readonly title = input<string>();
  /** Rejects further input once reached. Undefined leaves the field unlimited. */
  readonly maxLength = input<number>();

  readonly disabled = input(false, { transform: booleanAttribute });
  readonly validateWhenTouchedOnly = input(false, { transform: booleanAttribute });

  // Display all suggestions
  filterItems: SuggestionItemsFilter = (_query, items) => of(items);
}
